import _ from "lodash";
export class ServicesService {
  constructor(app, axios, apiUrl, apiCmsUrl, cmsImageUrl, store) {
    this.app = app;
    this.$axios = axios;
    this.apiUrl = apiUrl;
    this.apiCmsUrl = apiCmsUrl;
    this.cmsImageUrl = cmsImageUrl;
    this.store = store;
  }

  /**
   * Gets the service by scope
   * @param {integer} id
   * @returns
   */
  async getServices(id) {
    return await this.$axios
      .get(this.apiUrl + "Services", {
        headers: {
          "X-SessionId": id,
        },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  /**
   * Gets the service by id
   * @param {integer} id
   * @returns
   */
  async getServicesById(id, sqldbid) {
    return await this.$axios
      .get(this.apiUrl + "Services/RGS/Service/" + id + "/Company/" + sqldbid)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  // Unreferenced
  async getServicesByCategory(category) {
    return await this.$axios
      .get(this.apiCmsUrl + "services/" + category)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  async getServicesBySearch(sqldbid, search) {
    return await this.$axios
      .post(this.apiUrl + `Services/Search/Company/${sqldbid}`, search)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  existsInCart(serviceId, items) {
    let exists = false;
    let id = serviceId; //192573;
    let orderItems = items;
    if (orderItems) {
      Object.keys(orderItems).some(function (k) {
        if (orderItems[k].uP_ServiceDefinitionId === id) {
          exists = true;
        }
      });
    }
    return exists;
  }

  // Deprecated
  async getServiceDataFromState(persistedState) {
    var customerScopeId = persistedState.scope
      ? persistedState.scope.id
      : false;
    var franchiseScopeId =
      customerScopeId && persistedState.scope.franchiseOnlyScope
        ? persistedState.scope.franchiseOnlyScope.id
        : false;
    var data = await this.getBranchServiceData(
      true,
      franchiseScopeId,
      customerScopeId
    );
    var serviceData = this.createServicesObject(data.octoberCmsData);
    if (data.franchisePricingData || data.customerPricingData) {
      serviceData.applyUniversalPricing(
        data.franchisePricingData,
        data.customerPricingData
      );
    } else {
      serviceData.showCheckAvailability();
    }
    if (persistedState.order) {
      serviceData.applyOrders(persistedState.order);
    }
    return serviceData;
  }

  async getBranchServiceData(
    getOctoberData,
    franchiseScopeId,
    customerScopeId
  ) {
    var octoberCmsData = undefined;
    var customerPricingData = undefined;
    var franchisePricingData = undefined;

    var promises = [];

    // Get data from October
    if (getOctoberData) {
      promises.push(
        this.$axios
          .get(this.apiCmsUrl + "services")
          .then(function (response) {
            octoberCmsData = response.data;
          })
          .catch(function (error) {
            return { error: error, response: error.response.data };
          })
      );
    }

    // Get data from Universal Pricing for the franchise
    if (franchiseScopeId) {
      promises.push(
        this.$axios
          .get(this.apiUrl + "Services", {
            headers: { "X-SessionId": franchiseScopeId },
          })
          .then(function (response) {
            franchisePricingData = response.data;
          })
          .catch(function (error) {
            return { error: error, response: error.response.data };
          })
      );
    }

    // Get data from Universal Pricing for the user
    if (customerScopeId) {
      promises.push(
        this.$axios
          .get(this.apiUrl + "Services", {
            headers: { "X-SessionId": customerScopeId },
          })
          .then((response) => {
            customerPricingData = response.data;
            
            // save the customer data id in the persisted state for later reference
            try {
              if (this.store && this.store.state && this.store.state.persistedState) {
                const ps = this.store.state.persistedState;

                if (Array.isArray(customerPricingData)) {
                  ps.customerDataIds = customerPricingData.map((d) => d?.id).filter(Boolean).sort();
                }
              }
            } catch (e) {
              console.warn("Unable to save customerPricingData to persistedState", e);
            }

          })
          .catch(function (error) {
            return { error: error, response: error.response.data };
          })
      );
    }

    await Promise.all(promises);

    return {
      octoberCmsData: octoberCmsData,
      customerPricingData: customerPricingData,
      franchisePricingData: franchisePricingData,
    };
  }

  // Deprecated
  createServicesObject(octoberCmsData) {
    var services = {};
    var serviceIds = [];
    var serviceNames = [];
    var serviceSlugs = [];
    const imagePath = this.cmsImageUrl;

    // Go through all of the october data and add objects for them
    octoberCmsData.forEach(function (item) {
      var obj = {
        ServiceDefId: parseInt(item.omni_service_id),
        ServiceName: item.name,
        ServiceDesc: item.excerpt,
        ServiceImage: imagePath + item.featured_image,
        ServiceSlug: item.slug,
        ServiceVideo1: item.service_youtube_video_1
          ? item.service_youtube_video_1
          : undefined,
        ServiceVideo2: item.service_youtube_video_2
          ? item.service_youtube_video_2
          : undefined,
        ServiceCategory: item.service_category,
        UniversalPricing: undefined,
        orderData: undefined,
        addons: [],
        addonsTo: [],
        isAddon: false,
        isQuoteOnly: false,
        isInitialPayment: false,
        parent: undefined,
        addedToCart: false,
        initialPriceServiceId: undefined,
        initialPrice: 0,
        initialPriceService: undefined,
        mainPrice: 0,
        remainingRounds: 0,
        remainingPrice: 0,
        seasonRounds: 0,
        seasonPrice: 0,
        loadedPricingData: false,
        showPurchase: false,
        showCheckAvailability: false,
        showHasPurchased: false,
      };
      services[obj.ServiceDefId] = obj;
      services[item.name.trim()] = obj;
      services[item.slug.trim()] = obj;
      serviceIds.push(obj.ServiceDefId);
      serviceNames.push(item.name.trim());
      serviceSlugs.push(item.slug.trim());
    });

    return {
      octoberCmsData: octoberCmsData,
      universalPricingData: undefined,
      services: services,
      serviceIds: serviceIds,
      serviceNames: serviceNames,
      serviceSlugs: serviceSlugs,
      orders: undefined,
      loadedPricingData: false,
      $services: this,

      // Get the additions for the service
      getServiceAdditions(service) {
        const additionNames = service.addons;
        const services = this.services;
        var additions = [];
        additionNames.forEach(function (id) {
          additions.push(services[id]);
        });
        return additions;
      },

      // Add the universal pricing data, even adding items that weren't found before
      // Refactored
      applyUniversalPricing(franchisePricingData, customerPricingData) {
        if (!franchisePricingData && !customerPricingData) {
          this.showCheckAvailability();
        } else if (franchisePricingData && !customerPricingData) {
          customerPricingData = franchisePricingData;
        }

        const services = this.services;
        var universalPricingIds = [];

        // Get user data from universal pricing
        customerPricingData.forEach(function (item) {
          var service = undefined;
          if (item.id in services) {
            service = services[item.id];
            service.UniversalPricing = item;
          } else if (item.name in services) {
            service = services[item.name];
            service.UniversalPricing = item;
          } else {
            service = {
              ServiceDefId: item.id,
              ServiceName: item.name,
              ServiceDesc: item.description,
              ServiceImage: undefined,
              ServiceSlug: undefined,
              ServiceCategory: undefined,
              ServiceVideo1: undefined,
              ServiceVideo2: undefined,
              UniversalPricing: item,
              orderData: undefined,
              addons: [],
              addonsTo: [],
              isAddon: false,
              parent: undefined,
              addedToCart: false,
              initialPriceServiceId: undefined,
              initialPrice: 0,
              initialPriceService: undefined,
              loadedPricingData: false,
              showCheckAvailability: false,
              showHasPurchased: false,
            };
            services[item.id] = service;
            services[item.name.trim()] = service;
            serviceIds.push(item.id);
            serviceNames.push(item.name.trim());
          }

          universalPricingIds.push(service.ServiceDefId);
          service.ServiceDesc = service.UniversalPricing.description;
          service.isMonthly = service.UniversalPricing.billingFrequency.id == 2;
          service.isQuoteOnly = service.UniversalPricing.quoteOnly;
          service.isInitialPayment = service.UniversalPricing.initialPayment;
          service.mainPrice = service.UniversalPricing.finalPrice;
          service.remainingRounds = service.UniversalPricing.remainingRounds;
          service.remainingPrice = service.UniversalPricing.remainingSubTotal;
          service.seasonRounds = service.UniversalPricing.remainingRounds;
          service.seasonPrice = service.initialPrice;
          service.showPurchase = service.mainPrice != 0;
        });

        // Go through services the user has purchased
        if (franchisePricingData) {
          franchisePricingData.forEach(function (item) {
            var service = undefined;
            if (item.id in services) {
              service = services[item.id];
              if (!service.UniversalPricing) {
                service.UniversalPricing = item;
                service.showHasPurchased = true;
              }
            } else {
              service = {
                ServiceDefId: item.id,
                ServiceName: item.name,
                ServiceDesc: item.description,
                ServiceImage: undefined,
                ServiceSlug: undefined,
                ServiceCategory: undefined,
                ServiceVideo1: undefined,
                ServiceVideo2: undefined,
                UniversalPricing: item,
                orderData: undefined,
                addons: [],
                addonsTo: [],
                isAddon: false,
                parent: undefined,
                addedToCart: false,
                initialPriceServiceId: undefined,
                initialPrice: 0,
                initialPriceService: undefined,
                loadedPricingData: false,
                showCheckAvailability: false,
                showHasPurchased: true,
              };
              services[item.id] = service;
              services[item.name.trim()] = service;
              serviceIds.push(item.id);
              serviceNames.push(item.name.trim());
            }

            // If this service's universal pricing is new, set all the basic details
            if (service.UniversalPricing == item) {
              universalPricingIds.push(service.ServiceDefId);
              service.ServiceDesc = service.UniversalPricing.description;
              service.isMonthly =
                service.UniversalPricing.billingFrequency.id == 2;
              service.mainPrice = service.UniversalPricing.finalPrice;
              service.remainingRounds =
                service.UniversalPricing.remainingRounds;
              service.remainingPrice =
                service.UniversalPricing.remainingSubTotal;
              service.seasonRounds = service.UniversalPricing.remainingRounds;
              service.seasonPrice = service.initialPrice;
              service.showPurchase = false;
            }
          });
        }

        // Setup links for add-ons/bundles
        universalPricingIds.forEach(function (id) {
          var service = services[id];
          if (service.UniversalPricing && service.UniversalPricing.bundle) {
            service.UniversalPricing.bundle.forEach(function (bundleItem) {
              var bundleService = services[bundleItem.id];
              if (bundleService) {
                if (
                  bundleService.UniversalPricing &&
                  bundleService.UniversalPricing.initialPayment
                ) {
                  service.initialPriceServiceId = bundleService.ServiceDefId;
                  service.initialPrice =
                    bundleService.UniversalPricing.finalPrice;
                  service.initialPriceService = bundleService;
                } else {
                  service.addons.push(bundleService.ServiceDefId);
                  bundleService.addonsTo.push(id);
                  bundleService.isAddon = true;
                }
              } else {
                console.error(
                  service.ServiceName +
                    " bundle service of service id " +
                    bundleItem.id +
                    " not found"
                );
              }
            });
          }
        });

        // Set preferred lawn service to be above economy if no rank is found
        if (this.serviceIds.includes(2) && this.serviceIds.includes(3)) {
          var preferredService = this.services[2];
          var economyService = this.services[3];
          if (
            preferredService.UniversalPricing &&
            economyService.UniversalPricing &&
            !preferredService.UniversalPricing.rank &&
            !economyService.UniversalPricing.rank
          ) {
            preferredService.UniversalPricing.rank = -10;
            economyService.UniversalPricing.rank = -9;
          }
        }

        // Mark all as having their prices being loaded
        this.serviceIds.forEach(function (id) {
          services[id].loadedPricingData = true;
        });
        this.loadedPricingData = true;
        this.franchisePricingData = franchisePricingData;
        this.customerPricingData = customerPricingData;
      },

      // Refactored
      showCheckAvailability() {
        const services = this.services;
        this.serviceIds.forEach(function (id) {
          services[id].loadedPricingData = true;
          services[id].showCheckAvailability = true;
        });
        this.loadedPricingData = true;
      },

      // Applies the user's current orders to the services
      // Refactored
      applyOrders(orders) {
        this.orders = orders;

        const services = this.services;
        this.serviceIds.forEach(function (id) {
          services[id].addedToCart = false;
          services[id].orderData = undefined;
        });

        orders.orderItems?.forEach(function (order) {
          if (order.uP_ServiceDefinitionId in services) {
            services[order.uP_ServiceDefinitionId].orderData = order;
            services[order.uP_ServiceDefinitionId].addedToCart = true;
          } else if (order.title in services) {
            services[order.title].orderData = order;
            services[order.title].addedToCart = true;
          }
        });
      },

      // Adds the given service to the cart
      // Refactored
      async addServiceToCart(service, $orders, $sessions, store) {
        const persistedState = store.state.persistedState;

        store.commit("SET_SHOW_LOADER", true);

        // Todo: this would be better done in a way not hard coded
        var exclusions = [];
        if (service.ServiceName.includes("Total Home")) {
          exclusions = [33, 34, 37];
        } else if (service.ServiceName.includes("Lawn Care Program")) {
          exclusions = [2, 3];
        }

        // check if an order exists would be in a prop
        let orderId = null;

        if (
          persistedState.order &&
          persistedState.order.orderStatus === "PENDING"
        ) {
          orderId = persistedState.order.id;
        } else {
          // create orderId
          const userInfo = {
            custNo: persistedState.scope.cust_No,
          };

          const orderInfo = await $orders.createOrder(
            userInfo,
            persistedState.scope.id
          );
          if (orderInfo) {
            orderId = orderInfo.id;
          } else {
            return {
              successful: false,
              message:
                "There was an unknown error starting a new order for you",
              removedServiceIds: [],
            };
          }

          // get all scope info here
          const scopeInfo = await $sessions.getSessionById(
            persistedState.scope.id
          );
          if (scopeInfo) {
            store.commit("SET_SCOPE", scopeInfo);
          } else {
            return {
              successful: false,
              message: "There was an unknown error getting your session",
              removedServiceIds: [],
            };
          }
        }

        // Clear old services if need be
        var toRemoveServices = [];
        var allServices = this.services;
        for (var i = 0; i < exclusions.length; i++) {
          var exclusionId = exclusions[i];
          if (exclusionId in allServices) {
            var exclusionService = allServices[exclusionId];
            if (exclusionService.orderData) {
              var response = await this.removeServiceFromCart(
                exclusionService,
                $orders,
                store
              );
              response.removedServiceIds.forEach(function (id) {
                toRemoveServices.push(id);
              });
            }
          }
        }

        var orderItem = {
          orderId: orderId,
          uP_ServiceDefinitionId: service.ServiceDefId,
        };

        var addItem = await $orders.addItemToExistingOrder(
          orderId,
          orderItem,
          persistedState.scope.id
        );

        if (
          !addItem.error &&
          service.initialPriceServiceId &&
          service.initialPriceServiceId !== undefined
        ) {
          var initialPaymentService =
            allServices[service.initialPriceServiceId];
          orderItem = {
            orderId: orderId,
            uP_ServiceDefinitionId: initialPaymentService.ServiceDefId,
          };
          addItem = await $orders.addItemToExistingOrder(
            orderId,
            orderItem,
            persistedState.scope.id
          );
        }

        store.commit("SET_SHOW_LOADER", false);

        if (addItem.error) {
          let msg = addItem.error.response.data.Message;
          if (msg.includes("Conflict")) {
            return {
              successful: false,
              message:
                "We could not add this service because of a conflicting service already in your cart.",
              removedServiceIds: toRemoveServices,
            };
          } else {
            return {
              successful: false,
              message: "",
              removedServiceIds: toRemoveServices,
            };
          }
        } else {
          this.applyOrders(addItem);
          store.commit("SET_ORDER_INFORMATION", addItem);

          return {
            successful: true,
            message: "",
            removedServiceIds: toRemoveServices,
          };
        }
      },

      // Refactored
      async removeServiceFromCart(service, $orders, store) {
        const persistedState = store.state.persistedState;
        var orderId = persistedState.order.id;
        var removedServiceIds = [];
        var allServices = this.services;
        var orderData = undefined;
        if (service.orderData) {
          // Initial payment service
          if (service.initialPriceServiceId) {
            var initialPaymentService =
              allServices[service.initialPriceServiceId];
            if (initialPaymentService.orderData) {
              removedServiceIds.push(initialPaymentService.ServiceDefId);
              await $orders.removeItemInExistingOrder(
                orderId,
                initialPaymentService.orderData.id,
                persistedState.scope.id
              );
            }
          }

          // Add ons
          if (service.addons) {
            for (var i = 0; i < service.addons.length; i++) {
              var addonService = allServices[service.addons[i]];
              if (addonService.orderData) {
                removedServiceIds.push(addonService.ServiceDefId);
                await $orders.removeItemInExistingOrder(
                  orderId,
                  addonService.orderData.id,
                  persistedState.scope.id
                );
              }
            }
          }

          // Selected service
          removedServiceIds.push(service.ServiceDefId);
          orderData = await $orders.removeItemInExistingOrder(
            orderId,
            service.orderData.id,
            persistedState.scope.id
          );

          // NDC extra service
          // NB: this must come after the main service, elsewise the back-end just adds it back immediately.
          const ndcInfo = store.state.persistedState.ndcInfo;
          if (
            ndcInfo?.pricingRule == "FreeService" &&
            ndcInfo?.product?.id == service.ServiceDefId
          ) {
            const extraService = allServices[ndcInfo.product.extraService?.id];
            if (extraService?.orderData) {
              orderData = await $orders.removeItemInExistingOrder(
                orderId,
                extraService.orderData.id,
                persistedState.scope.id
              );

              removedServiceIds.push(extraService.ServiceDefId);
            }
          }

          store.commit("SET_ORDER_INFORMATION", orderData);
        }

        return {
          removedServiceIds: removedServiceIds,
          orderData: orderData,
        };
      },

      // Refactored
      isParentServicePurchased(service) {
        var response = false;
        const services = this.services;
        service.addonsTo.forEach(function (id) {
          var parentService = services[id];
          if (parentService.orderData || parentService.showHasPurchased) {
            response = true;
          }
        });
        return response;
      },

      // Refactored
      getServicesByName(names) {
        const services = this.services;
        var toReturn = [];
        names.forEach(function (name) {
          if (name in services) {
            toReturn.push(services[name]);
          }
        });
        return toReturn;
      },

      // Refactored
      getServicesByIds(ids, availableOnly = false) {
        const services = this.services;
        var toReturn = [];
        ids.forEach(function (id) {
          if (parseInt(id) in services) {
            var service = services[parseInt(id)];
            if (!availableOnly || service.showPurchase || service.isQuoteOnly)
              toReturn.push(service);
          }
        });
        return toReturn;
      },

      // Deprecated
      getServicesByCategory(category) {
        const services = this.services;
        var toReturn = [];
        serviceIds.forEach(function (id) {
          var service = services[id];
          if (service.ServiceCategory == category) {
            toReturn.push(service);
          }
        });
        return toReturn;
      },

      // Refactored
      sortServices(services) {
        services.sort(function (a, b) {
          const rankA = a.UniversalPricing?.rank ?? 999999;
          const rankB = b.UniversalPricing?.rank ?? 999999;

          return rankA - rankB;
        });
      },

      // Refactored
      findPageServices(object, pageData) {
        if (pageData.featured_program && pageData.featured_program.length > 0) {
          object.featuredServices = this.getServicesByName(
            pageData.featured_program
          );
        } else if (
          pageData.featured_programs &&
          pageData.featured_programs.length > 0
        ) {
          object.featuredServices = this.getServicesByName(
            pageData.featured_programs
          );
        } else if (
          pageData.feature_programs &&
          pageData.feature_programs.length > 0
        ) {
          object.featuredServices = this.getServicesByName(
            pageData.feature_programs
          );
        }

        if (pageData.add_on_services && pageData.add_on_services.length > 0) {
          object.addonServices = this.getServicesByName(
            pageData.add_on_services
          );
        }

        if (pageData.upsell_services && pageData.upsell_services.length > 0) {
          object.upsellServices = this.getServicesByName(
            pageData.upsell_services
          );
        }

        if (pageData.related_services && pageData.related_services.length > 0) {
          object.relatedServices = this.getServicesByName(
            pageData.related_services
          );
        }
      },

      // Deprecated
      async applyStateAsync(store, getFranchiseOnlyData = false) {
        if (
          store.state.persistedState.scope &&
          store.state.persistedState.scope.id
        ) {
          var franchiseScopeId = store.state.persistedState.scope
            .franchiseOnlyScope
            ? store.state.persistedState.scope.franchiseOnlyScope.id
            : false;
          var data = await this.$services.getBranchServiceData(
            false,
            getFranchiseOnlyData ? franchiseScopeId : undefined,
            store.state.persistedState.scope.id
          );
          if (data.franchisePricingData || data.customerPricingData) {
            this.applyUniversalPricing(
              data.franchisePricingData,
              data.customerPricingData
            );
          }
        } else {
          this.showCheckAvailability();
        }

        if (store.state.persistedState.order) {
          this.applyOrders(store.state.persistedState.order);
        }
      },

      // Refactored
      getCartServices() {
        let servicesInCart = [];

        this.serviceIds.forEach((id) => {
          const service = this.services[id];
          if (
            service.addedToCart &&
            service.UniversalPricing &&
            //!service.UniversalPricing.initialPayment &&
            !service.showHasPurchased
          ) {
            servicesInCart.push(service);
          }
        });

        return servicesInCart;
      },
    };
  }

  async loadServiceData() {
    const persistedState = this.store.state.persistedState;

    const branchServiceData = await this.getBranchServiceData(
      true,
      false,
      persistedState.scope?.id
    );

    const services = {};
    const serviceIds = []; // TODO: Eliminate this storage bloat in favor of on-demand filtering
    const serviceNames = {};
    const serviceSlugs = {};
    const imagePath = this.cmsImageUrl;

    branchServiceData.octoberCmsData.forEach(function (item) {
      let obj = {
        ServiceDefId: parseInt(item.omni_service_id),
        ServiceName: item.name,
        ServiceDesc: item.excerpt,
        ServiceImage: imagePath + item.featured_image,
        ServiceSlug: item.slug,
        ServiceVideo1: item.service_youtube_video_1
          ? item.service_youtube_video_1
          : undefined,
        ServiceVideo2: item.service_youtube_video_2
          ? item.service_youtube_video_2
          : undefined,
        ServiceCategory: item.service_category,
        UniversalPricing: undefined,
        orderData: undefined,
        addons: [],
        addonsTo: [],
        isAddon: false,
        isQuoteOnly: false,
        isInitialPayment: false,
        parent: undefined,
        addedToCart: false,
        initialPriceServiceId: undefined,
        initialPrice: 0,
        initialPriceService: undefined,
        mainPrice: 0,
        remainingRounds: 0,
        remainingPrice: 0,
        seasonRounds: 0,
        seasonPrice: 0,
        loadedPricingData: false,
        showPurchase: false,
        showCheckAvailability: false,
        showHasPurchased: false,
      };
      services[obj.ServiceDefId] = obj;
      //   services[item.name.trim()] = obj; // Eliminated this storage bloat in favor of on-demand filtering.
      //   services[item.slug.trim()] = obj; // Deprecated

      serviceIds.push(obj.ServiceDefId); // TODO: Eliminate this storage bloat in favor of on-demand filtering
      serviceNames[item.name.trim()] = obj.ServiceDefId;
      serviceSlugs[item.slug.trim()] = obj.ServiceDefId;
    });

    const serviceData = {
      //   octoberCmsData: branchServiceData.octoberCmsData, // Deprecated
      //   universalPricingData: undefined, // Deprecated
      services: services,
      serviceIds: serviceIds, // TODO: Eliminate this storage bloat in favor of on-demand filtering
      serviceNames: serviceNames,
      serviceSlugs: serviceSlugs,
      // orders: undefined, // Deprecated
      loadedPricingData: false,
    };

    this.store.commit("SET_SERVICE_DATA", serviceData);

    if (branchServiceData.customerPricingData) {
      await this.applyUniversalPricing(branchServiceData.customerPricingData);
    } else {
      await this.showCheckAvailability();
    }
  }

  async applyUniversalPricing(customerPricingData) {
    const serviceData = _.cloneDeep(
      this.store.state.persistedState.serviceData
    );
    const services = serviceData.services;
    const universalPricingIds = [];
    const branchAdditSvcs = this.store.state.persistedState.branchInfo?.BranchAdditSvc;

    // Get user data from universal pricing
    customerPricingData.forEach(function (item) {
      let service = undefined;

      if (item.id in services) {
        service = services[item.id];
        service.UniversalPricing = item;
      }
      //   else if (services.filter(function(s){ return s.ServiceName == item.name; })) {
      //     service = services[item.name];
      //     service.UniversalPricing = item;
      //   }
      else {
        service = {
          ServiceDefId: item.id,
          ServiceName: item.name,
          ServiceDesc: item.description,
          ServiceImage: undefined,
          ServiceSlug: undefined,
          ServiceCategory: undefined,
          ServiceVideo1: undefined,
          ServiceVideo2: undefined,
          UniversalPricing: item,
          orderData: undefined,
          addons: [],
          addonsTo: [],
          isAddon: false,
          parent: undefined,
          addedToCart: false,
          initialPriceServiceId: undefined,
          initialPrice: 0,
          initialPriceService: undefined,
          loadedPricingData: false,
          showCheckAvailability: false,
          showHasPurchased: false,
        };
        services[item.id] = service;
        // services[item.name.trim()] = service; // Eliminated this storage bloat in favor of on-demand filtering.
        serviceData.serviceIds.push(item.id); // TODO: Eliminate this storage bloat in favor of on-demand filtering.
        serviceData.serviceNames[item.name.trim()] = item.id;
      }

      // Get branch-specific service information to substitute, if available.
      const branchAdditSvc = branchAdditSvcs?.find((s) => s.ServiceDefId === service.ServiceDefId);

      universalPricingIds.push(service.ServiceDefId);
      service.ServiceName = !!branchAdditSvc?.BranchSpecific ? branchAdditSvc?.ServiceName : service.ServiceName;
      service.ServiceDesc = !!branchAdditSvc?.BranchSpecific ? branchAdditSvc?.ServiceDesc : service.UniversalPricing.description;
      service.isMonthly = service.UniversalPricing.billingFrequency.id == 2;
      service.isQuoteOnly = service.UniversalPricing.quoteOnly;
      service.isInitialPayment = service.UniversalPricing.initialPayment;
      service.mainPrice = service.UniversalPricing.finalPrice;
      service.remainingRounds = service.UniversalPricing.remainingRounds;
      service.remainingPrice = service.UniversalPricing.remainingSubTotal;
      service.seasonRounds = service.UniversalPricing.remainingRounds;
      service.seasonPrice = service.initialPrice;
      service.showPurchase = service.mainPrice != 0;
    });

    // Setup links for add-ons/bundles
    universalPricingIds.forEach(function (id) {
      const service = services[id];

      if (service.UniversalPricing?.bundle) {
        service.UniversalPricing.bundle.forEach(function (bundleItem) {
          var bundleService = services[bundleItem.id];
          if (bundleService) {
            if (
              bundleService.UniversalPricing &&
              bundleService.UniversalPricing.initialPayment
            ) {
              service.initialPriceServiceId = bundleService.ServiceDefId;
              service.initialPrice = bundleService.UniversalPricing.finalPrice;
              service.initialPriceService = bundleService;
            } else {
              service.addons.push(bundleService.ServiceDefId);
              bundleService.addonsTo.push(id);
              bundleService.isAddon = true;
            }
          } else {
            console.warn(
              service.ServiceName +
                " bundle service of service id " +
                bundleItem.id +
                " not found"
            );
          }
        });
      }
    });

    // Set preferred lawn service to be above economy if no rank is found
    if (
      serviceData.serviceIds.includes(2) &&
      serviceData.serviceIds.includes(3)
    ) {
      const preferredService = serviceData.services[2];
      const economyService = serviceData.services[3];
      if (
        preferredService.UniversalPricing &&
        economyService.UniversalPricing &&
        !preferredService.UniversalPricing.rank &&
        !economyService.UniversalPricing.rank
      ) {
        preferredService.UniversalPricing.rank = -10;
        economyService.UniversalPricing.rank = -9;
      }
    }

    // Mark all as having their prices being loaded
    serviceData.serviceIds.forEach(function (id) {
      services[id].loadedPricingData = true;
    });
    serviceData.loadedPricingData = true;
    // serviceData.franchisePricingData = franchisePricingData; // Deprecated
    // serviceData.customerPricingData = customerPricingData;  // Deprecated

    this.store.commit("SET_SERVICE_DATA", serviceData);
  }

  async showCheckAvailability() {
    const serviceData = _.cloneDeep(
      this.store.state.persistedState.serviceData
    );

    const services = serviceData.services;
    serviceData.serviceIds.forEach(function (id) {
      services[id].loadedPricingData = true;
      services[id].showCheckAvailability = true;
    });
    serviceData.loadedPricingData = true;

    this.store.commit("SET_SERVICE_DATA", serviceData);
  }

  async applyOrders(orders = null) {
    const serviceData = _.cloneDeep(
      this.store.state.persistedState.serviceData
    );
    // serviceData.orders = orders;

    if (!orders) {
      orders = this.store.state.persistedState.order;
    }

    if(!orders.orderItems) {
      orders.orderItems = [];
    }

    const services = serviceData.services;
    serviceData.serviceIds.forEach(function (id) {
      services[id].addedToCart = false;
      services[id].orderData = undefined;
    });

    orders.orderItems?.forEach(function (order) {
      if (order.uP_ServiceDefinitionId in services) {
        services[order.uP_ServiceDefinitionId].orderData = order;
        services[order.uP_ServiceDefinitionId].addedToCart = true;
      } else if (order.title in services) {
        services[order.title].orderData = order;
        services[order.title].addedToCart = true;
      }
    });

    this.store.commit("SET_SERVICE_DATA", serviceData);
  }

  async addServiceToCart(service) {
    const persistedState = this.store.state.persistedState;

    this.store.commit("SET_SHOW_LOADER", true);

    // check if an order exists would be in a prop
    let orderId = null;

    if (
      persistedState.order &&
      persistedState.order.orderStatus === "PENDING"
    ) {
      orderId = persistedState.order.id;
    } else {
      // create orderId
      const userInfo = {
        custNo: persistedState.scope.cust_No,
      };

      const orderInfo = await this.app.$orders.createOrder(
        userInfo,
        persistedState.scope.id
      );
      if (orderInfo) {
        orderId = orderInfo.id;
      } else {
        return {
          successful: false,
          message: "There was an unknown error starting a new order for you",
          removedServiceIds: [],
        };
      }

      // get all scope info here
      const scopeInfo = await this.app.$sessions.getSessionById(
        persistedState.scope.id
      );
      if (scopeInfo) {
        this.store.commit("SET_SCOPE", scopeInfo);
      } else {
        return {
          successful: false,
          message: "There was an unknown error getting your session",
          removedServiceIds: [],
        };
      }
    }

    // Todo: this would be better done in a way not hard coded
    var exclusions = [];
    if (service.ServiceName.includes("Total Home")) {
      exclusions = [33, 34, 37];
    } else if (service.ServiceName.includes("Lawn Care Program")) {
      exclusions = [2, 3];
    }

    // Clear old services if need be
    var toRemoveServices = [];
    var allServices = _.cloneDeep(
      this.store.state.persistedState.serviceData.services
    );
    for (var i = 0; i < exclusions.length; i++) {
      var exclusionId = exclusions[i];
      if (exclusionId in allServices) {
        var exclusionService = allServices[exclusionId];
        if (exclusionService.orderData) {
          var response = await this.removeServiceFromCart(exclusionService);
          response.removedServiceIds.forEach(function (id) {
            toRemoveServices.push(id);
          });
        }
      }
    }

    var orderItem = {
      orderId: orderId,
      uP_ServiceDefinitionId: service.ServiceDefId,
    };

    var addItem = await this.app.$orders.addItemToExistingOrder(
      orderId,
      orderItem,
      persistedState.scope.id
    );

    if (
      !addItem.error &&
      service.initialPriceServiceId &&
      service.initialPriceServiceId !== undefined
    ) {
      var initialPaymentService = allServices[service.initialPriceServiceId];
      orderItem = {
        orderId: orderId,
        uP_ServiceDefinitionId: initialPaymentService.ServiceDefId,
      };
      addItem = await this.app.$orders.addItemToExistingOrder(
        orderId,
        orderItem,
        persistedState.scope.id
      );
    }

    this.store.commit("SET_SHOW_LOADER", false);

    if (addItem.error) {
      let msg = addItem.error.response.data.Message;
      if (msg.includes("Conflict")) {
        return {
          successful: false,
          message:
            "We could not add this service because of a conflicting service already in your cart.",
          removedServiceIds: toRemoveServices,
        };
      } else {
        return {
          successful: false,
          message: "",
          removedServiceIds: toRemoveServices,
        };
      }
    } else {
      this.store.commit("SET_ORDER_INFORMATION", addItem);
      this.applyOrders();

      return {
        successful: true,
        message: "",
        removedServiceIds: toRemoveServices,
      };
    }
  }

  async removeServiceFromCart(service) {
    const persistedState = this.store.state.persistedState;
    const orderId = persistedState.order.id;
    const removedServiceIds = [];
    const allServices = this.store.state.persistedState.serviceData.services;
    let orderData = undefined;

    if (service.orderData) {
      // Initial payment service
      if (service.initialPriceServiceId) {
        var initialPaymentService = allServices[service.initialPriceServiceId];
        if (initialPaymentService.orderData) {
          removedServiceIds.push(initialPaymentService.ServiceDefId);
          await this.app.$orders.removeItemInExistingOrder(
            orderId,
            initialPaymentService.orderData.id,
            persistedState.scope.id
          );
        }
      }

      // Add ons
      if (service.addons) {
        for (var i = 0; i < service.addons.length; i++) {
          var addonService = allServices[service.addons[i]];
          if (addonService.orderData) {
            removedServiceIds.push(addonService.ServiceDefId);
            await this.app.$orders.removeItemInExistingOrder(
              orderId,
              addonService.orderData.id,
              persistedState.scope.id
            );
          }
        }
      }

      // Selected service
      removedServiceIds.push(service.ServiceDefId);
      orderData = await this.app.$orders.removeItemInExistingOrder(
        orderId,
        service.orderData.id,
        persistedState.scope.id
      );

      // NDC extra service
      // NB: this must come after the main service, elsewise the back-end just adds it back immediately.
      const ndcInfo = this.store.state.persistedState.ndcInfo;
      if (
        ndcInfo?.pricingRule == "FreeService" &&
        ndcInfo?.product?.id == service.ServiceDefId
      ) {
        const extraService = allServices[ndcInfo.product.extraService?.id];
        if (extraService?.orderData) {
          orderData = await this.app.$orders.removeItemInExistingOrder(
            orderId,
            extraService.orderData.id,
            persistedState.scope.id
          );

          removedServiceIds.push(extraService.ServiceDefId);
        }
      }

      orderData = await this.app.$orders.getOrderById(orderId, this.store.state.persistedState.scope.id);
      this.store.commit("SET_ORDER_INFORMATION", orderData);
      this.applyOrders();
    }

    return {
      removedServiceIds: removedServiceIds,
      orderData: orderData,
    };
  }

  async isParentServicePurchased(service) {
    let response = false;
    const services = this.store.state.persistedState.serviceData.services;
    service.addonsTo.forEach(function (id) {
      var parentService = services[id];
      if (parentService.orderData || parentService.showHasPurchased) {
        response = true;
      }
    });
    return response;
  }

  getServicesByName(names) {
    const serviceData = this.store.state.persistedState.serviceData;
    const toReturn = [];

    names.forEach((name) => {
      const serviceId = serviceData.serviceNames[name];
      if (serviceId) {
        toReturn.push(serviceData.services[serviceId]);
      }
    });

    return toReturn;
  }

  getServiceBySlug(slug) {
    const serviceData = this.store.state.persistedState.serviceData;

    if (!serviceData.serviceSlugs) {
      return null;
    }

    const serviceId = serviceData.serviceSlugs[slug];
    if (serviceId) {
      return serviceData.services[serviceId];
    } else {
      return null;
    }
  }

  getServicesByIds(ids, availableOnly = false, includeInitialServices = false) {
    const services = this.store.state.persistedState.serviceData?.services;
    const toReturn = [];
    if (services && Object.keys(services).length > 0) {
      ids.forEach(function (id) {
        if (parseInt(id) in services) {
          const service = services[parseInt(id)];

          if (service.isInitialPayment) {
            if (includeInitialServices && service.showPurchase) {
              toReturn.push(service);
            }
          } else if (
            !availableOnly ||
            service.showPurchase ||
            service.isQuoteOnly
          ) {
            toReturn.push(service);
          }
        }
      });
    }

    return toReturn;
  }

  sortServices(services) {
    services.sort(function (a, b) {
      const rankA = a.UniversalPricing?.rank ?? 999999;
      const rankB = b.UniversalPricing?.rank ?? 999999;

      return rankA - rankB;
    });
  }

  async findPageServices(pageData) {
    
    let retval = {
      featuredServices: undefined,
      addonServices: undefined,
      upsellServices: undefined,
      relatedServices: undefined
    }
    
    if (pageData.featured_program && pageData.featured_program.length > 0) {
      retval.featuredServices = this.getServicesByName(
        pageData.featured_program
      );
    } else if (
      pageData.featured_programs &&
      pageData.featured_programs.length > 0
    ) {
      retval.featuredServices = this.getServicesByName(
        pageData.featured_programs
      );
    } else if (
      pageData.feature_programs &&
      pageData.feature_programs.length > 0
    ) {
      retval.featuredServices = this.getServicesByName(
        pageData.feature_programs
      );
    }

    if (pageData.add_on_services && pageData.add_on_services.length > 0) {
      retval.addonServices = this.getServicesByName(
        pageData.add_on_services
      );
    }

    if (pageData.upsell_services && pageData.upsell_services.length > 0) {
      retval.upsellServices = this.getServicesByName(
        pageData.upsell_services
      );
    }

    if (pageData.related_services && pageData.related_services.length > 0) {
      retval.relatedServices = this.getServicesByName(
        pageData.related_services
      );
    }

    return retval;
  }

  getCartServices() {
    const serviceData = this.store.state.persistedState.serviceData;
    let servicesInCart = [];

    serviceData?.serviceIds?.forEach((id) => {
      const service = serviceData.services[id];
      if (
        service.addedToCart &&
        service.UniversalPricing &&
        !service.showHasPurchased
      ) {
        servicesInCart.push(service);
      }
    });

    return servicesInCart;
  }

  /** serviceData parameter optional */
  hasTotalHomePestControlService(services) {
    if (!services) {
      services = this.getCartServices();
    }

    return services.some((s) => this.isTotalHomePestControlService(s));
  }

  isTotalHomePestControlService(service) {
    return /^total home pest/i.test(service.ServiceName);
  }

  /** cartServices parameter optional */
  hasOnlyQuoteOnlyServices(cartServices) {
    if (!cartServices) {
      cartServices = this.getCartServices();
    }

    return cartServices.every((service) => service.isQuoteOnly);
  }

  isInitialVisitOfServiceInCart(serviceId, cartServices) {
    return cartServices.some((cartService) =>
      cartService.UniversalPricing?.bundle?.some(
        (bundleService) =>
          bundleService.id === serviceId && bundleService.initialPayment
      )
    );
  }
}
